
// const isTest = true;

export type PresetData = {
    dotCount: number,
    boxes: number,
    rad: number,
    speed: number,
    lives: number,
    rhythm: number,
}

const getRand = (min: number, max: number) =>
    Math.floor((Math.random() * (max - min)) + min);

export const getRandom = () => ({
    dotCount: getRand(1, 10),
    boxes: getRand(3, 25),
    rad: getRand(3, 20),
    speed: getRand(1, 10),
    lives: getRand(0, 30),
    rhythm: getRand(1, 12),
})

export const presets = [
    {
        name: "orig",
        data: {
            dotCount: 4,
            boxes: 12,
            rad: 10,
            speed: 10,
            lives: 0,
            rhythm: 6,
        }
    },
    {
        name: "wavey",
        data: {
            dotCount: 6,
            boxes: 50,
            rad: 5,
            speed: 5,
            lives: 60,
            rhythm: 120,
        }
    },
    {
        name: "toomany",
        data: {
            dotCount: 3,
            boxes: 50,
            rad: 100,
            speed: 5,
            lives: 0,
            rhythm: 12,
        }
    },
    {
        name: "speedy",
        data: {
            dotCount: 2,
            boxes: 5,
            rad: 30,
            speed: 55,
            lives: 30,
            rhythm: 4,
        }
    },
    {
        name: "scattered",
        data: {
            dotCount: 4,
            boxes: 5,
            rad: 10,
            speed: 15,
            lives: 1,
            rhythm: 8,
        }
    },
    {
        name: "biggy",
        data: {
            dotCount: 2,
            boxes: 4,
            rad: 30,
            speed: 15,
            lives: 0,
            rhythm: 4,
        }
    },
    {
        name: "looper",
        data: {
            dotCount: 3,
            boxes: 3,
            rad: 30,
            speed: 3,
            lives: 32,
            rhythm: 4,
        }
    },
    {
        name: "slooow",
        data: {
            dotCount: 3,
            boxes: 4,
            rad: 40,
            speed: 0.8,
            lives: 20,
            rhythm: 8,
        }
    },
    {
        name: "three",
        data: {
            dotCount: 3,
            boxes: 14,
            rad: 3,
            speed: 8,
            lives: 50,
            rhythm: 24,
        }
    },
    {
        name: "fcked",
        data: {
            dotCount: 4,
            boxes: 14,
            rad: 30,
            speed: 8,
            lives: 30,
            rhythm: 50,
        }
    },
    {
        name: "wack",
        data: {
            dotCount: 6,
            boxes: 4,
            rad: 50,
            speed: 10,
            lives: 10,
            rhythm: 62,
        }
    },
    {
        name: "good",
        data: {
            dotCount: 4,
            boxes: 8,
            rad: 10,
            speed: 6,
            lives: 30,
            rhythm: 12,
        }
    },
    {
        name: "madness",
        data: {
            dotCount: 10,
            boxes: 4,
            rad: 5,
            speed: 10,
            lives: 150,
            rhythm: 240,
        }
    },
    {
        name: "solo",
        data: {
            dotCount: 1,
            boxes: 12,
            rad: 10,
            speed: 6,
            lives: 24,
            rhythm: 1,
        }
    }
]
// export const bounceConfig = toomany;

// export type 